(() => {
  'use strict';
  const section = document.querySelector('#customer-reviews');
  if (!section || section.dataset.photoGalleryReady) return;
  section.dataset.photoGalleryReady = 'true';
  const labels = {"en":["Customer review photos","Close photo","Previous photo","Next photo"],"fr":["Photos des avis clients","Fermer la photo","Photo précédente","Photo suivante"],"de":["Kundenfotos","Foto schließen","Vorheriges Foto","Nächstes Foto"],"es":["Fotos de clientes","Cerrar foto","Foto anterior","Foto siguiente"],"it":["Foto dei clienti","Chiudi foto","Foto precedente","Foto successiva"],"nl":["Klantfoto’s","Foto sluiten","Vorige foto","Volgende foto"],"pt-PT":["Fotografias de clientes","Fechar fotografia","Fotografia anterior","Fotografia seguinte"],"pt-BR":["Fotos de clientes","Fechar foto","Foto anterior","Próxima foto"],"cs":["Fotografie zákazníků","Zavřít fotografii","Předchozí fotografie","Další fotografie"],"ja":["お客様のレビュー写真","写真を閉じる","前の写真","次の写真"],"ko":["고객 리뷰 사진","사진 닫기","이전 사진","다음 사진"]};
  const language = document.documentElement.lang;
  const text = labels[language] || labels[language.split('-')[0]] || labels.en;
  const dialog = document.createElement('dialog');
  if (typeof dialog.showModal !== 'function') return;
  dialog.className = 'bvm-review-photo-dialog';
  dialog.setAttribute('aria-label', text[0]);
  dialog.innerHTML = '<button type="button" class="bvm-review-photo-dialog__control bvm-review-photo-dialog__close" aria-label="Close customer photo" autofocus>×</button><button type="button" class="bvm-review-photo-dialog__control bvm-review-photo-dialog__prev" aria-label="Previous customer photo">‹</button><img class="bvm-review-photo-dialog__image" alt=""><button type="button" class="bvm-review-photo-dialog__control bvm-review-photo-dialog__next" aria-label="Next customer photo">›</button><p class="bvm-review-photo-dialog__caption" aria-live="polite"></p>';
  dialog.querySelector('.bvm-review-photo-dialog__close').setAttribute('aria-label', text[1]);
  dialog.querySelector('.bvm-review-photo-dialog__prev').setAttribute('aria-label', text[2]);
  dialog.querySelector('.bvm-review-photo-dialog__next').setAttribute('aria-label', text[3]);
  document.body.append(dialog);
  const image = dialog.querySelector('img');
  const caption = dialog.querySelector('p');
  const previous = dialog.querySelector('.bvm-review-photo-dialog__prev');
  const next = dialog.querySelector('.bvm-review-photo-dialog__next');
  let links = [], index = 0, trigger = null, author = '', overflow = '', touchX = null;
  const render = () => {
    const link = links[index];
    image.src = link.href;
    image.alt = link.querySelector('img')?.alt || text[0];
    caption.textContent = (author ? author + ' · ' : '') + (index + 1) + ' / ' + links.length;
    previous.hidden = next.hidden = links.length < 2;
  };
  const move = direction => { index = (index + direction + links.length) % links.length; render(); };
  section.addEventListener('click', event => {
    const link = event.target.closest('.bvm-collection-review-card__photo-link');
    if (!link || !section.contains(link) || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    trigger = link;
    links = [...link.closest('.bvm-collection-review-card__photos').querySelectorAll('.bvm-collection-review-card__photo-link')];
    index = links.indexOf(link);
    author = link.closest('.bvm-collection-review-card').querySelector('.bvm-collection-review-card__name')?.textContent.trim() || '';
    render();
    overflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
  });
  dialog.querySelector('.bvm-review-photo-dialog__close').addEventListener('click', () => dialog.close());
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); }
  });
  image.addEventListener('touchstart', event => { touchX = event.touches.length === 1 ? event.touches[0].clientX : null; }, { passive: true });
  image.addEventListener('touchend', event => {
    if (touchX !== null && event.changedTouches.length && Math.abs(event.changedTouches[0].clientX - touchX) > 50) move(event.changedTouches[0].clientX < touchX ? 1 : -1);
    touchX = null;
  }, { passive: true });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = overflow;
    image.removeAttribute('src');
    trigger?.focus({ preventScroll: true });
  });
})();
